import { render } from "./KongJieModelPage.vue?vue&type=template&id=1aa81735&scoped=true"
import script from "./KongJieModelPage.vue?vue&type=script&lang=js"
export * from "./KongJieModelPage.vue?vue&type=script&lang=js"

import "./KongJieModelPage.vue?vue&type=style&index=0&id=1aa81735&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa81735"]])

export default __exports__